import * as React from "react";
import { Box, MenuItem, FormControlLabel, Radio, Checkbox } from "@mui/material";
import { addSnapshot, getDetailsReportV2 } from "state/apis";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "./index.css";
import Header from "components/Header";
import { TextField, Grid } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import moment from "moment";
import DefaultProperty from "components/DefaultProperty";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { formatAmount } from "utils/constants";
import Loader from "components/Loader";

const IncomeExpenseDetailsV2 = () => {
    const propertyName = useSelector((state) => state.global.propertyName);
    const property = useSelector((state) => state.global.defaultProperty);
    const [isLoading, setIsLoading] = React.useState(false);
    console.log("isLoading: ", isLoading);
    const [data, setData] = React.useState({});
    const [openDefaultProperty, setOpenDefaultProperty] = React.useState(false);
    const [monthChecked, setMonthChecked] = React.useState(true);
    const [dateChecked, setDateChecked] = React.useState(false);
    const [onlyReceipts, setOnlyReceipts] = React.useState(false);
    console.log("onlyReceipts: ", onlyReceipts);

    const start = moment().startOf("month").format("YYYY-MM-DD");
    const end = moment().endOf("month").format("YYYY-MM-DD");
    const currentMonth = moment().format("YYYY-MM");

    const [filter, setFilter] = React.useState({
        startDate: start,
        endDate: end,
        monthValue: currentMonth,
        reportType: "Income and expense summary",
        onlyReceipt: false,
        // isNewContract: true,
    });

    React.useEffect(() => {
        setIsLoading(true);
        if (!property) {
            setOpenDefaultProperty(true);
        } else {
            fetchData();
        }

        setIsLoading(false);
    }, [
        filter.startDate,
        filter.endDate,
        monthChecked,
        property,
        filter.onlyReceipt,
        // filter.isNewContract,
    ]);

    React.useEffect(() => {
        setIsLoading(true);
        if (!property) {
            setOpenDefaultProperty(true);
        } else {
            fetchData();
        }

        setIsLoading(false);
    }, []);

    const fetchData = async () => {
        try {
            let res = await getDetailsReportV2({
                propertyId: property,
                startDate: filter.startDate,
                endDate: filter.endDate,
                onlyReceipt: filter.onlyReceipt,
                // isNewContract: filter.isNewContract,
            });
            setData(res.data);
            setIsLoading(false);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const handleMonthChange = (event) => {
        const isChecked = event.target.checked;
        setMonthChecked(isChecked);
        if (isChecked) {
            setDateChecked(false);
        }
    };

    const handleDateChange = (event) => {
        const isChecked = event.target.checked;
        setDateChecked(isChecked);
        if (isChecked) {
            setMonthChecked(false);
        }
    };

    const handleFrom = (date) => {
        const data = date;
        const formattedDate = data.format("YYYY-MM-DD");

        setFilter((prevData) => ({
            ...prevData,
            startDate: formattedDate,
        }));
    };
    const handleTo = (date) => {
        const data = date;
        const formattedDate = data.format("YYYY-MM-DD");

        setFilter((prevData) => ({
            ...prevData,
            endDate: formattedDate,
        }));
    };
    const handleMonth = (date) => {
        if (!date) return;
        const selectedDate = dayjs(date);

        const startDate = selectedDate.startOf("month").format("YYYY-MM-DD");
        const endDate = selectedDate.endOf("month").format("YYYY-MM-DD");

        setFilter((prevData) => ({
            ...prevData,
            startDate: startDate,
            endDate: endDate,
            monthValue: date ? date.format("YYYY-MM") : null,
        }));
    };

    // const handleNewContract = (e) => {
    //     const value = e.target.checked;
    //     setFilter((prevData) => ({
    //         ...prevData,
    //         isNewContract: value,
    //     }));
    // };

    const handleCloseDefaultProperty = () => {
        setOpenDefaultProperty(false);
    };
    const handleOnlyReceipts = (e) => {
        let value = e.target.checked;
        if (value) {
            setFilter((prevData) => ({
                ...prevData,
                onlyReceipt: true,
            }));
        } else {
            setFilter((prevData) => ({
                ...prevData,
                onlyReceipt: false,
            }));
        }
    };

    const reportRef = React.useRef();
    const saveSnapshot = async () => {
        setIsLoading(true);
        const input = reportRef.current;

        try {
            const canvas = await html2canvas(input, { scale: 2 });
            const imgData = canvas.toDataURL("image/png", 0.7);
            const pdf = new jsPDF("l", "mm", "a3");

            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();
            const margin = 10;
            const imgProps = pdf.getImageProperties(imgData);
            const imgHeight = (imgProps.height * (pdfWidth - 2 * margin)) / imgProps.width;
            let position = 0;

            while (position < canvas.height) {
                const sectionCanvas = document.createElement("canvas");
                const sectionHeight = Math.min(
                    canvas.height - position,
                    (pdfHeight - 2 * margin) * (imgProps.width / (pdfWidth - 2 * margin))
                );

                sectionCanvas.width = canvas.width;
                sectionCanvas.height = sectionHeight;

                const sectionCtx = sectionCanvas.getContext("2d");
                sectionCtx.drawImage(canvas, 0, -position, canvas.width, canvas.height);

                const sectionImgData = sectionCanvas.toDataURL("image/png", 0.7);

                if (position > 0) pdf.addPage();
                pdf.addImage(
                    sectionImgData,
                    "PNG",
                    margin,
                    margin,
                    pdfWidth - 2 * margin,
                    (sectionHeight * (pdfWidth - 2 * margin)) / canvas.width
                );

                position += sectionHeight;
            }

            const pdfBlob = pdf.output("blob");
            const uniqueFileName = `${propertyName}-${moment(filter.startDate).format(
                "MMM"
            )}-${moment(filter.startDate).format("YYYY")}.pdf`;

            const pdfFile = new File([pdfBlob], uniqueFileName, { type: "application/pdf" });

            const snapshotData = {
                fileName: `${propertyName}-${moment(filter.startDate).format("MMM")}-${moment(
                    filter.startDate
                ).format("YYYY")}-income-and-expense.pdf`,
                uniqueName: uniqueFileName,
                fileUrl: pdfFile,
            };

            const response = await addSnapshot(snapshotData);
            console.log("response: ", response);
            setIsLoading(false);
            toast.success(response.message);
            // console.log("Snapshot uploaded successfully:", response);
        } catch (error) {
            console.error("Error:", error);
            if (error.response) {
                toast.error(error.response.data.message);
            } else if (error.request) {
                toast.error("No response received from server.");
            } else {
                toast.error("An error occurred. Please try again.");
            }
        }
    };

    // const handlePrint = () => {
    //     const input = reportRef.current;

    //     html2canvas(input, { scale: 2 }).then((canvas) => {
    //         const imgData = canvas.toDataURL("image/png");
    //         const pdf = new jsPDF("l", "mm", "a4");

    //         const pdfWidth = pdf.internal.pageSize.getWidth();
    //         const pdfHeight = pdf.internal.pageSize.getHeight();

    //         const sideMargin = 5;
    //         const topMargin = 5;

    //         const imgProps = pdf.getImageProperties(imgData);
    //         const imgHeight = (imgProps.height * (pdfWidth - 2 * sideMargin)) / imgProps.width;

    //         let heightLeft = imgHeight;
    //         let position = topMargin;

    //         pdf.addImage(
    //             imgData,
    //             "PNG",
    //             sideMargin,
    //             position,
    //             pdfWidth - 2 * sideMargin,
    //             imgHeight
    //         );
    //         heightLeft -= pdfHeight - 2 * topMargin;

    //         while (heightLeft > 0) {
    //             pdf.addPage();
    //             position = topMargin;
    //             pdf.addImage(
    //                 imgData,
    //                 "PNG",
    //                 sideMargin,
    //                 position,
    //                 pdfWidth - 2 * sideMargin,
    //                 imgHeight
    //             );
    //             heightLeft -= pdfHeight - 2 * topMargin;
    //         }

    //         pdf.save(`${propertyName}-income-and-expense.pdf`);
    //     });
    // };

    // landscape last
    // const handlePrint = () => {
    //     const input = reportRef.current;

    //     html2canvas(input, { scale: 2 }).then((canvas) => {
    //         const imgData = canvas.toDataURL("image/png");

    //         // Create PDF with landscape orientation and A4 size
    //         const pdf = new jsPDF("l", "mm", "a4");

    //         const pdfWidth = pdf.internal.pageSize.getWidth();
    //         const pdfHeight = pdf.internal.pageSize.getHeight();

    //         const margin = 10; // Margin (padding)

    //         const imgProps = pdf.getImageProperties(imgData);
    //         const imgHeight = (imgProps.height * (pdfWidth - 2 * margin)) / imgProps.width;

    //         let heightLeft = imgHeight;
    //         let position = margin;

    //         // Add the first image to the PDF
    //         pdf.addImage(imgData, "PNG", margin, position, pdfWidth - 2 * margin, imgHeight);
    //         heightLeft -= pdfHeight - 2 * margin;

    //         // If the image exceeds one page, add more pages
    //         while (heightLeft > 0) {
    //             pdf.addPage();
    //             position = margin;
    //             pdf.addImage(imgData, "PNG", margin, position, pdfWidth - 2 * margin, imgHeight);
    //             heightLeft -= pdfHeight - 2 * margin;
    //         }

    //         pdf.save(`${propertyName}-income-and-expense.pdf`);
    //     });
    // };

    const handlePrint = () => {
        const input = reportRef.current;

        html2canvas(input, { scale: 2 }).then((canvas) => {
            // Lower scale for optimization
            const imgData = canvas.toDataURL("image/png", 0.7); // Reduce image quality
            const pdf = new jsPDF("l", "mm", "a3"); // Landscape A3 PDF

            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();

            const margin = 10;
            const imgProps = pdf.getImageProperties(imgData);
            const imgHeight = (imgProps.height * (pdfWidth - 2 * margin)) / imgProps.width;

            let position = 0;

            // Draw each section of the canvas on a new PDF page
            while (position < canvas.height) {
                const sectionCanvas = document.createElement("canvas");
                const sectionHeight = Math.min(
                    canvas.height - position,
                    (pdfHeight - 2 * margin) * (imgProps.width / (pdfWidth - 2 * margin))
                );

                sectionCanvas.width = canvas.width;
                sectionCanvas.height = sectionHeight;

                const sectionCtx = sectionCanvas.getContext("2d");
                sectionCtx.drawImage(canvas, 0, -position, canvas.width, canvas.height);

                const sectionImgData = sectionCanvas.toDataURL("image/png", 0.7);

                if (position > 0) pdf.addPage();
                pdf.addImage(
                    sectionImgData,
                    "PNG",
                    margin,
                    margin,
                    pdfWidth - 2 * margin,
                    (sectionHeight * (pdfWidth - 2 * margin)) / canvas.width
                );

                position += sectionHeight;
            }

            pdf.save(`${propertyName}-income-and-expense.pdf`);
        });
    };

    // const handlePrint = () => {
    //     const input = reportRef.current;

    //     html2canvas(input, { scale: 3 }).then((canvas) => {
    //         const imgData = canvas.toDataURL("image/png");
    //         const pdf = new jsPDF("l", "mm", "a3"); // Landscape A3 PDF

    //         const pdfWidth = pdf.internal.pageSize.getWidth();
    //         const pdfHeight = pdf.internal.pageSize.getHeight();

    //         const margin = 10;
    //         const imgProps = pdf.getImageProperties(imgData);
    //         const imgHeight = (imgProps.height * (pdfWidth - 2 * margin)) / imgProps.width;

    //         let heightLeft = imgHeight;
    //         let position = margin;

    //         pdf.addImage(imgData, "PNG", margin, position, pdfWidth - 2 * margin, imgHeight);
    //         heightLeft -= pdfHeight - 2 * margin;

    //         while (heightLeft > 0) {
    //             position = heightLeft - imgHeight + margin;
    //             pdf.addPage();
    //             pdf.addImage(imgData, "PNG", margin, position, pdfWidth - 2 * margin, imgHeight);
    //             heightLeft -= pdfHeight - 2 * margin;
    //         }

    //         pdf.save(`${propertyName}-income-and-expense.pdf`);
    //     });
    // };

    // original
    // const handlePrint = () => {
    //     const input = reportRef.current;

    //     html2canvas(input, { scale: 2 }).then((canvas) => {
    //         const imgData = canvas.toDataURL("image/png");
    //         const pdf = new jsPDF("p", "mm", "a4");

    //         const pdfWidth = pdf.internal.pageSize.getWidth();
    //         const pdfHeight = pdf.internal.pageSize.getHeight();

    //         const margin = 10; // Add margin (padding)

    //         const imgProps = pdf.getImageProperties(imgData);
    //         const imgHeight = (imgProps.height * (pdfWidth - 2 * margin)) / imgProps.width;

    //         let heightLeft = imgHeight;
    //         let position = margin;

    //         pdf.addImage(imgData, "PNG", margin, position, pdfWidth - 2 * margin, imgHeight);
    //         heightLeft -= pdfHeight - 2 * margin;

    //         while (heightLeft > 0) {
    //             position = heightLeft - imgHeight + margin;
    //             pdf.addPage();
    //             pdf.addImage(imgData, "PNG", margin, position, pdfWidth - 2 * margin, imgHeight);
    //             heightLeft -= pdfHeight - 2 * margin;
    //         }

    //         pdf.save(`${propertyName}-income-and-expense.pdf`);
    //     });
    // };
    let totalOtherIncome = 0;
    let totalDeposit = 0;
    return (
        <Box m="1.5rem 2.5rem" mb={5}>
            <Box display="flex" justifyContent="flex-end" pt={0} paddingLeft={0}>
                <Grid container spacing={1} p={"5px"} alignItems="center">
                    <Grid item xs={2}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={data.vacant}
                                    onChange={(e) => handleOnlyReceipts(e)}
                                    name="vacant"
                                    color="primary"
                                />
                            }
                            label="Only Receipts"
                        />
                    </Grid>
                    {/* <Grid item xs={2}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={filter.isNewContract}
                                    onChange={handleNewContract}
                                    name="isNewContract"
                                    color="primary"
                                />
                            }
                            label="New Contract"
                        />
                    </Grid> */}
                    <Grid item>
                        <FormControlLabel
                            value="month"
                            control={
                                <Radio
                                    checked={monthChecked}
                                    onChange={handleMonthChange}
                                    color="primary"
                                />
                            }
                            label="Month"
                        />
                    </Grid>
                    <Grid item>
                        <FormControlLabel
                            value="date"
                            control={
                                <Radio
                                    checked={dateChecked}
                                    onChange={handleDateChange}
                                    color="primary"
                                />
                            }
                            label="Date Wise"
                        />
                    </Grid>
                    {dateChecked && (
                        <>
                            <Grid item xs={2}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label="From"
                                        name="contractFrom"
                                        onChange={handleFrom}
                                        value={filter.startDate ? dayjs(filter.startDate) : null}
                                        format="DD/MM/YYYY"
                                        sx={{
                                            width: "100%",
                                            "& .MuiOutlinedInput-root": {
                                                "&.Mui-focused fieldset": {
                                                    borderColor: "primary.main",
                                                },
                                            },
                                            "& .MuiInputLabel-root": {
                                                "&.Mui-focused": {
                                                    color: "primary.main",
                                                },
                                            },
                                        }}
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={2}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label="To"
                                        name="contractTo"
                                        onChange={handleTo}
                                        value={filter.endDate ? dayjs(filter.endDate) : null}
                                        format="DD/MM/YYYY"
                                        sx={{
                                            width: "100%",
                                            "& .MuiOutlinedInput-root": {
                                                "&.Mui-focused fieldset": {
                                                    borderColor: "primary.main",
                                                },
                                            },
                                            "& .MuiInputLabel-root": {
                                                "&.Mui-focused": {
                                                    color: "primary.main",
                                                },
                                            },
                                        }}
                                    />
                                </LocalizationProvider>
                            </Grid>
                        </>
                    )}
                    {monthChecked && (
                        <Grid item xs={2}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label={"Month"}
                                    views={["month", "year"]}
                                    name="month"
                                    onChange={handleMonth}
                                    value={filter.monthValue ? dayjs(filter.monthValue) : null}
                                    sx={{
                                        width: "100%",
                                        "& .MuiOutlinedInput-root": {
                                            "&.Mui-focused fieldset": {
                                                borderColor: "primary.main",
                                            },
                                        },
                                        "& .MuiInputLabel-root": {
                                            "&.Mui-focused": {
                                                color: "primary.main",
                                            },
                                        },
                                    }}
                                />
                            </LocalizationProvider>
                        </Grid>
                    )}
                    <Grid item xs></Grid>
                    <Grid item xs="auto">
                        <button
                            className="download-btn"
                            onClick={saveSnapshot}
                            disabled={isLoading}
                        >
                            {isLoading ? (
                                <Loader size={25} color="#ffffff" marginLeft="1px" />
                            ) : (
                                "Snapshot"
                            )}
                        </button>
                    </Grid>
                    <Grid item xs="auto">
                        <button className="download-btn" onClick={handlePrint}>
                            Download PDF
                        </button>
                    </Grid>
                </Grid>
            </Box>
            {!property && (
                <DefaultProperty
                    open={openDefaultProperty}
                    onClose={() => handleCloseDefaultProperty}
                />
            )}
            <div className="report-container">
                <div ref={reportRef}>
                    <table border="1" cellPadding="5" cellSpacing="0">
                        <thead>
                            <tr>
                                <th colSpan={17} style={{ textAlign: "center" }}>
                                    {propertyName}
                                </th>
                                <th colSpan={3} style={{ textAlign: "center" }}>
                                    {propertyName}
                                </th>
                            </tr>
                            <tr>
                                <th colSpan={17} style={{ textAlign: "center" }}>
                                    {monthChecked
                                        ? `DETAILS OF INCOME AND EXPENSE FOR THE MONTH OF  ${moment(
                                              filter.monthValue
                                          )
                                              .format("MMMM YYYY")
                                              .toUpperCase()}`
                                        : `DETAILS OF INCOME AND EXPENSE FOR THE PERIOD OF  ${filter.startDate} AND ${filter.endDate}`}
                                </th>
                                <th colSpan={3} style={{ textAlign: "center" }}>
                                    {monthChecked
                                        ? `Exps (${moment(filter.monthValue).format("MMM-YYYY")})`
                                        : `EXPENSE FOR TH PERIOD OF  ${filter.startDate} AND ${filter.endDate}`}
                                </th>
                            </tr>
                            <tr>
                                <th rowSpan={1} style={{ textAlign: "center" }}>
                                    SL NO
                                </th>
                                <th style={{ textAlign: "center" }}>UNIT</th>
                                <th colSpan={2} style={{ textAlign: "center" }}>
                                    CONTRACT PERIOD
                                </th>
                                <th></th>
                                <th colSpan={2} style={{ textAlign: "center" }}>
                                    REMAINING CHQS
                                </th>
                                <th colSpan={4} style={{ textAlign: "center" }}>
                                    RENT COLLECTED
                                </th>
                                <th colSpan={2} style={{ textAlign: "center" }}>
                                    DEPOSIT
                                </th>
                                <th style={{ textAlign: "center" }}>BAL</th>
                                <th style={{ textAlign: "center" }}>DAYS</th>
                                <th style={{ textAlign: "center" }}>DUE AMT</th>
                                <th style={{ textAlign: "center" }}>REMARK</th>
                                <th></th>
                                <th></th>
                                <th></th>
                            </tr>
                            <tr>
                                <th></th>
                                <th></th>
                                <th style={{ textAlign: "center" }}>FROM</th>
                                <th style={{ textAlign: "center" }}>TO</th>
                                <th style={{ textAlign: "center" }}>RENT</th>
                                <th style={{ textAlign: "center" }}>CHQ DATE</th>
                                <th style={{ textAlign: "center" }}>AMOUNT</th>
                                <th style={{ textAlign: "center" }}>DATE</th>
                                <th style={{ textAlign: "center" }}>AMOUNT</th>
                                <th style={{ textAlign: "center" }}>REC NO</th>
                                <th style={{ textAlign: "center" }}>UP TO</th>
                                <th style={{ textAlign: "center" }}>DATE</th>
                                <th style={{ textAlign: "center" }}>Amount</th>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th style={{ textAlign: "center" }}>DATE</th>
                                <th style={{ textAlign: "center" }}>Description</th>
                                <th style={{ textAlign: "center" }}>AMOUNT</th>
                                {/* <th style={{ textAlign: "center" }}>DESCRIPTION</th> */}
                            </tr>
                        </thead>

                        <tbody>
                            {data && data.data ? (
                                <>
                                    {data.data.map((val, index) => {
                                        const isContractExpired =
                                            val.contractTo &&
                                            moment(val.contractTo).isBefore(moment(filter.endDate));
                                        const rowStyle = {
                                            backgroundColor: isContractExpired
                                                ? "#ff8080"
                                                : "transparent",
                                        };
                                        return val.vacant === 0 ? (
                                            <tr key={index} style={rowStyle}>
                                                <td>{index + 1}</td>
                                                <td>
                                                    {val.unitNumber}
                                                    <br />
                                                    {val?.vacantLabel === "Yes" ? (
                                                        <span style={{ color: "red" }}>Vacant</span>
                                                    ) : (
                                                        ""
                                                    )}
                                                </td>
                                                <td
                                                    style={{
                                                        cursor: val?.contractDoc
                                                            ? "pointer"
                                                            : "default",
                                                    }}
                                                    onClick={() =>
                                                        window.open(val?.contractDoc?.url, "_blank")
                                                    }
                                                >
                                                    {val.contractFrom
                                                        ? moment(val.contractFrom).format(
                                                              "DD/MM/YYYY"
                                                          )
                                                        : "-"}
                                                </td>
                                                <td>
                                                    {val.contractTo
                                                        ? moment(val.contractTo).format(
                                                              "DD/MM/YYYY"
                                                          )
                                                        : "-"}
                                                </td>
                                                <td style={{ textAlign: "right" }}>
                                                    {formatAmount(Number(val.yearRent))}
                                                </td>
                                                <td
                                                    style={{
                                                        padding: "0px",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    <ul
                                                        style={{
                                                            listStyleType: "none",
                                                            padding: 0,
                                                            margin: 0,
                                                            width: "85px",
                                                        }}
                                                    >
                                                        {val.remainingCheques.length > 0 ? (
                                                            val.remainingCheques.map((ele, idx) => {
                                                                const isLast =
                                                                    idx ===
                                                                    val.remainingCheques.length - 1;
                                                                return (
                                                                    <li
                                                                        key={idx}
                                                                        style={{
                                                                            paddingBottom: "5px",
                                                                            marginBottom: "5px",
                                                                            borderBottom: isLast
                                                                                ? "none"
                                                                                : "1px solid #ccc",
                                                                        }}
                                                                    >
                                                                        {moment(
                                                                            ele.chequeDate
                                                                        ).format("DD/MM/YYYY")}
                                                                    </li>
                                                                );
                                                            })
                                                        ) : (
                                                            <li
                                                                style={{
                                                                    paddingBottom: "5px",
                                                                    marginBottom: "5px",
                                                                }}
                                                            >
                                                                -
                                                            </li>
                                                        )}
                                                    </ul>
                                                </td>
                                                <td
                                                    style={{
                                                        padding: "0px",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    <ul
                                                        style={{
                                                            listStyleType: "none",
                                                            padding: 0,
                                                            margin: 0,
                                                        }}
                                                    >
                                                        {val.remainingCheques.length > 0 ? (
                                                            val.remainingCheques.map((ele, idx) => {
                                                                const amount =
                                                                    parseFloat(ele.amount) || 0;
                                                                const paidAmount =
                                                                    parseFloat(ele.paidAmount) || 0;
                                                                const remainingAmount =
                                                                    amount - paidAmount;
                                                                const isLast =
                                                                    idx ===
                                                                    val.remainingCheques.length - 1;
                                                                return (
                                                                    <li
                                                                        key={idx}
                                                                        style={{
                                                                            paddingBottom: "5px",
                                                                            marginBottom: "5px",
                                                                            textAlign: "right",
                                                                            borderBottom: isLast
                                                                                ? "none"
                                                                                : "1px solid #ccc",
                                                                        }}
                                                                    >
                                                                        <span
                                                                            style={{
                                                                                padding: "8px",
                                                                            }}
                                                                        >
                                                                            {formatAmount(
                                                                                remainingAmount
                                                                            )}
                                                                        </span>
                                                                    </li>
                                                                );
                                                            })
                                                        ) : (
                                                            <li
                                                                style={{
                                                                    paddingBottom: "5px",
                                                                    marginBottom: "5px",
                                                                }}
                                                            >
                                                                -
                                                            </li>
                                                        )}
                                                    </ul>
                                                </td>
                                                <td
                                                    style={{
                                                        padding: "0px",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    <ul
                                                        style={{
                                                            listStyleType: "none",
                                                            padding: 0,
                                                            margin: 0,
                                                            width: "85px",
                                                        }}
                                                    >
                                                        {val.receipt.length > 0 ? (
                                                            val.receipt.map((ele, idx) => {
                                                                const isLast =
                                                                    idx === val.receipt.length - 1;
                                                                return (
                                                                    <li
                                                                        key={idx}
                                                                        style={{
                                                                            paddingBottom: "5px",
                                                                            marginBottom: "5px",
                                                                            borderBottom: isLast
                                                                                ? "none"
                                                                                : "1px solid #ccc",
                                                                        }}
                                                                    >
                                                                        {moment(ele.date).format(
                                                                            "DD/MM/YYYY"
                                                                        )}
                                                                    </li>
                                                                );
                                                            })
                                                        ) : (
                                                            <li
                                                                style={{
                                                                    paddingBottom: "5px",
                                                                    marginBottom: "5px",
                                                                }}
                                                            >
                                                                -
                                                            </li>
                                                        )}
                                                    </ul>
                                                </td>
                                                <td
                                                    style={{
                                                        padding: "0px",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    <ul
                                                        style={{
                                                            listStyleType: "none",
                                                            padding: 0,
                                                            margin: 0,
                                                        }}
                                                    >
                                                        {val.receipt.length > 0 ? (
                                                            val.receipt.map((ele, idx) => {
                                                                const isLast =
                                                                    idx === val.receipt.length - 1;
                                                                return (
                                                                    <li
                                                                        key={idx}
                                                                        style={{
                                                                            paddingBottom: "5px",
                                                                            marginBottom: "5px",
                                                                            textAlign: "right",
                                                                            borderBottom: isLast
                                                                                ? "none"
                                                                                : "1px solid #ccc",
                                                                        }}
                                                                    >
                                                                        <span
                                                                            style={{
                                                                                padding: "8px",
                                                                            }}
                                                                        >
                                                                            {formatAmount(
                                                                                Number(ele.amount)
                                                                            )}
                                                                        </span>
                                                                    </li>
                                                                );
                                                            })
                                                        ) : (
                                                            <li
                                                                style={{
                                                                    paddingBottom: "5px",
                                                                    marginBottom: "5px",
                                                                }}
                                                            >
                                                                -
                                                            </li>
                                                        )}
                                                    </ul>
                                                </td>
                                                <td
                                                    style={{
                                                        padding: "0px",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    <ul
                                                        style={{
                                                            listStyleType: "none",
                                                            padding: 0,
                                                            margin: 0,
                                                        }}
                                                    >
                                                        {val.receipt.length > 0 ? (
                                                            val.receipt.map((ele, idx) => {
                                                                const isLast =
                                                                    idx === val.receipt.length - 1;
                                                                return (
                                                                    <li
                                                                        key={idx}
                                                                        style={{
                                                                            paddingBottom: "5px",
                                                                            marginBottom: "5px",
                                                                            borderBottom: isLast
                                                                                ? "none"
                                                                                : "1px solid #ccc",
                                                                        }}
                                                                    >
                                                                        {ele.bankRefNumber}
                                                                    </li>
                                                                );
                                                            })
                                                        ) : (
                                                            <li
                                                                style={{
                                                                    paddingBottom: "5px",
                                                                    marginBottom: "5px",
                                                                }}
                                                            >
                                                                -
                                                            </li>
                                                        )}
                                                    </ul>
                                                </td>
                                                <td>{val.paidUntilDate}</td>
                                                <td
                                                    style={{
                                                        padding: "0px",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    <ul
                                                        style={{
                                                            listStyleType: "none",
                                                            padding: 0,
                                                            margin: 0,
                                                            width: "90px",
                                                        }}
                                                    >
                                                        {val.deposits.length > 0 ? (
                                                            val.deposits.map((ele, idx) => {
                                                                const isLast =
                                                                    idx === val.deposits.length - 1;
                                                                return (
                                                                    <li
                                                                        key={idx}
                                                                        style={{
                                                                            paddingBottom: "5px",
                                                                            marginBottom: "5px",
                                                                            borderBottom: isLast
                                                                                ? "none"
                                                                                : "1px solid #ccc",
                                                                        }}
                                                                    >
                                                                        {moment(ele.date).format(
                                                                            "DD/MM/YYYY"
                                                                        )}
                                                                    </li>
                                                                );
                                                            })
                                                        ) : (
                                                            <li
                                                                style={{
                                                                    paddingBottom: "5px",
                                                                    marginBottom: "5px",
                                                                }}
                                                            >
                                                                -
                                                            </li>
                                                        )}
                                                    </ul>
                                                </td>
                                                <td
                                                    style={{
                                                        padding: "0px",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    <ul
                                                        style={{
                                                            listStyleType: "none",
                                                            padding: 0,
                                                            margin: 0,
                                                        }}
                                                    >
                                                        {val.deposits.length > 0 ? (
                                                            val.deposits.map((ele, idx) => {
                                                                const amount =
                                                                    parseFloat(ele.amount) || 0;
                                                                totalDeposit += amount;
                                                                const isLast =
                                                                    idx === val.deposits.length - 1;
                                                                return (
                                                                    <li
                                                                        key={idx}
                                                                        style={{
                                                                            paddingBottom: "5px",
                                                                            marginBottom: "5px",
                                                                            textAlign: "right",
                                                                            borderBottom: isLast
                                                                                ? "none"
                                                                                : "1px solid #ccc",
                                                                        }}
                                                                    >
                                                                        {`${formatAmount(amount)}`}
                                                                    </li>
                                                                );
                                                            })
                                                        ) : (
                                                            <li
                                                                style={{
                                                                    paddingBottom: "5px",
                                                                    marginBottom: "5px",
                                                                }}
                                                            >
                                                                -
                                                            </li>
                                                        )}
                                                    </ul>
                                                </td>
                                                <td style={{ textAlign: "right" }}>
                                                    {val.balanceAmount
                                                        ? formatAmount(Number(val.balanceAmount))
                                                        : "-"}
                                                </td>
                                                <td
                                                    style={{
                                                        textAlign: "right",
                                                        color: val.dayDiff < 0 ? "red" : "inherit",
                                                    }}
                                                >
                                                    {val.dayDiff}
                                                </td>

                                                <td style={{ textAlign: "right" }}>
                                                    {formatAmount(Number(val.dueAmount))}
                                                </td>
                                                <td style={{ textAlign: "center" }}>
                                                    {val?.vacantLabel === "Yes" &&
                                                    val?.terminatedDate
                                                        ? moment(val.terminatedDate).format(
                                                              "DD/MM/YYYY"
                                                          )
                                                        : "-"}
                                                </td>
                                                {/* <td
                                                    style={{ textAlign: "right" }}
                                                >{`Number(val.unitExpenses).toFixed(2)}</td> */}
                                                <td
                                                    style={{
                                                        padding: "0px",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    <ul
                                                        style={{
                                                            listStyleType: "none",
                                                            padding: 0,
                                                            margin: 0,
                                                            width: "85px",
                                                        }}
                                                    >
                                                        {val.expense.length > 0 ? (
                                                            val.expense.map((ele, idx) => {
                                                                const isLast =
                                                                    idx === val.expense.length - 1;
                                                                return (
                                                                    <li
                                                                        key={idx}
                                                                        style={{
                                                                            paddingBottom: "5px",
                                                                            marginBottom: "5px",
                                                                            borderBottom: isLast
                                                                                ? "none"
                                                                                : "1px solid #ccc",
                                                                            cursor: ele?.attachment
                                                                                ? "pointer"
                                                                                : "default",
                                                                        }}
                                                                        onClick={() =>
                                                                            window.open(
                                                                                ele?.attachment,
                                                                                "_blank"
                                                                            )
                                                                        }
                                                                    >
                                                                        {moment(ele.date).format(
                                                                            "DD/MM/YYYY"
                                                                        )}
                                                                    </li>
                                                                );
                                                            })
                                                        ) : (
                                                            <li
                                                                style={{
                                                                    paddingBottom: "5px",
                                                                    marginBottom: "5px",
                                                                }}
                                                            >
                                                                -
                                                            </li>
                                                        )}
                                                    </ul>
                                                </td>
                                                <td
                                                    style={{
                                                        padding: "0px",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    <ul
                                                        style={{
                                                            listStyleType: "none",
                                                            padding: 0,
                                                            margin: 0,
                                                            width: "200px",
                                                        }}
                                                    >
                                                        {val.expense.length > 0 ? (
                                                            val.expense.map((ele, idx) => {
                                                                const isLast =
                                                                    idx === val.expense.length - 1;
                                                                return (
                                                                    <li
                                                                        key={idx}
                                                                        style={{
                                                                            paddingBottom: "5px",
                                                                            marginBottom: "5px",
                                                                            borderBottom: isLast
                                                                                ? "none"
                                                                                : "1px solid #ccc",
                                                                        }}
                                                                    >
                                                                        {/* {ele?.expense_type?.name}
                                                                         */}
                                                                        {ele?.description
                                                                            ? ele?.description
                                                                            : ele?.remarks}
                                                                    </li>
                                                                );
                                                            })
                                                        ) : (
                                                            <li
                                                                style={{
                                                                    paddingBottom: "5px",
                                                                    marginBottom: "5px",
                                                                }}
                                                            >
                                                                -
                                                            </li>
                                                        )}
                                                    </ul>
                                                </td>
                                                <td
                                                    style={{
                                                        padding: "0px",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    <ul
                                                        style={{
                                                            listStyleType: "none",
                                                            padding: 0,
                                                            margin: 0,
                                                        }}
                                                    >
                                                        {val.expense.length > 0 ? (
                                                            val.expense.map((ele, idx) => {
                                                                const isLast =
                                                                    idx === val.expense.length - 1;
                                                                return (
                                                                    <li
                                                                        key={idx}
                                                                        style={{
                                                                            paddingBottom: "5px",
                                                                            marginBottom: "5px",
                                                                            textAlign: "right",
                                                                            borderBottom: isLast
                                                                                ? "none"
                                                                                : "1px solid #ccc",
                                                                        }}
                                                                    >
                                                                        <span
                                                                            style={{
                                                                                padding: "8px",
                                                                            }}
                                                                        >
                                                                            {formatAmount(
                                                                                Number(ele?.amount)
                                                                            )}
                                                                        </span>
                                                                    </li>
                                                                );
                                                            })
                                                        ) : (
                                                            <li
                                                                style={{
                                                                    paddingBottom: "5px",
                                                                    marginBottom: "5px",
                                                                }}
                                                            >
                                                                -
                                                            </li>
                                                        )}
                                                    </ul>
                                                </td>
                                            </tr>
                                        ) : (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{val.unitNumber}</td>
                                                <td colSpan={10}>VACANT</td>
                                            </tr>
                                        );
                                    })}

                                    {data?.futureReceipts?.length > 0 && (
                                        <>
                                            <tr>
                                                <td
                                                    colSpan="20"
                                                    style={{ textAlign: "center" }}
                                                ></td>
                                            </tr>
                                            <tr>
                                                <td colSpan="20" style={{ textAlign: "start" }}>
                                                    Additional Collections
                                                </td>
                                            </tr>
                                        </>
                                    )}
                                    {data?.futureReceipts.map((val, index) => {
                                        const isContractExpired =
                                            val.contractTo &&
                                            moment(val.contractTo).isBefore(moment(filter.endDate));
                                        const rowStyle = {
                                            backgroundColor: isContractExpired
                                                ? "#ff8080"
                                                : "transparent",
                                        };
                                        return (
                                            <tr key={index} style={rowStyle}>
                                                <td>{index + 1}</td>
                                                <td>
                                                    {val.unitNumber}
                                                    <br />
                                                    {val?.vacantLabel === "Yes" ? (
                                                        <span style={{ color: "red" }}>Vacant</span>
                                                    ) : (
                                                        ""
                                                    )}
                                                </td>
                                                <td>
                                                    {val.contractFrom
                                                        ? moment(val.contractFrom).format(
                                                              "DD/MM/YYYY"
                                                          )
                                                        : "-"}
                                                </td>
                                                <td>
                                                    {val.contractTo
                                                        ? moment(val.contractTo).format(
                                                              "DD/MM/YYYY"
                                                          )
                                                        : "-"}
                                                </td>
                                                <td style={{ textAlign: "right" }}>
                                                    {formatAmount(Number(val.yearRent))}
                                                </td>
                                                <td
                                                    style={{
                                                        padding: "0px",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    <ul
                                                        style={{
                                                            listStyleType: "none",
                                                            padding: 0,
                                                            margin: 0,
                                                            width: "85px",
                                                        }}
                                                    >
                                                        {val.remainingCheques.length > 0 ? (
                                                            val.remainingCheques.map((ele, idx) => {
                                                                const isLast =
                                                                    idx ===
                                                                    val.remainingCheques.length - 1;
                                                                return (
                                                                    <li
                                                                        key={idx}
                                                                        style={{
                                                                            paddingBottom: "5px",
                                                                            marginBottom: "5px",
                                                                            borderBottom: isLast
                                                                                ? "none"
                                                                                : "1px solid #ccc",
                                                                        }}
                                                                    >
                                                                        {moment(
                                                                            ele.chequeDate
                                                                        ).format("DD/MM/YYYY")}
                                                                    </li>
                                                                );
                                                            })
                                                        ) : (
                                                            <li
                                                                style={{
                                                                    paddingBottom: "5px",
                                                                    marginBottom: "5px",
                                                                }}
                                                            >
                                                                -
                                                            </li>
                                                        )}
                                                    </ul>
                                                </td>
                                                <td
                                                    style={{
                                                        padding: "0px",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    <ul
                                                        style={{
                                                            listStyleType: "none",
                                                            padding: 0,
                                                            margin: 0,
                                                        }}
                                                    >
                                                        {val.remainingCheques.length > 0 ? (
                                                            val.remainingCheques.map((ele, idx) => {
                                                                const amount =
                                                                    parseFloat(ele.amount) || 0;
                                                                const paidAmount =
                                                                    parseFloat(ele.paidAmount) || 0;
                                                                const remainingAmount =
                                                                    amount - paidAmount;
                                                                const isLast =
                                                                    idx ===
                                                                    val.remainingCheques.length - 1;
                                                                return (
                                                                    <li
                                                                        key={idx}
                                                                        style={{
                                                                            paddingBottom: "5px",
                                                                            marginBottom: "5px",
                                                                            textAlign: "right",
                                                                            borderBottom: isLast
                                                                                ? "none"
                                                                                : "1px solid #ccc",
                                                                        }}
                                                                    >
                                                                        <span
                                                                            style={{
                                                                                padding: "8px",
                                                                            }}
                                                                        >
                                                                            {formatAmount(
                                                                                remainingAmount
                                                                            )}
                                                                        </span>
                                                                    </li>
                                                                );
                                                            })
                                                        ) : (
                                                            <li
                                                                style={{
                                                                    paddingBottom: "5px",
                                                                    marginBottom: "5px",
                                                                }}
                                                            >
                                                                -
                                                            </li>
                                                        )}
                                                    </ul>
                                                </td>
                                                <td
                                                    style={{
                                                        padding: "0px",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    <ul
                                                        style={{
                                                            listStyleType: "none",
                                                            padding: 0,
                                                            margin: 0,
                                                            width: "85px",
                                                        }}
                                                    >
                                                        {val.receipt.length > 0 ? (
                                                            val.receipt.map((ele, idx) => {
                                                                const isLast =
                                                                    idx === val.receipt.length - 1;
                                                                return (
                                                                    <li
                                                                        key={idx}
                                                                        style={{
                                                                            paddingBottom: "5px",
                                                                            marginBottom: "5px",
                                                                            borderBottom: isLast
                                                                                ? "none"
                                                                                : "1px solid #ccc",
                                                                        }}
                                                                    >
                                                                        {moment(ele.date).format(
                                                                            "DD/MM/YYYY"
                                                                        )}
                                                                    </li>
                                                                );
                                                            })
                                                        ) : (
                                                            <li
                                                                style={{
                                                                    paddingBottom: "5px",
                                                                    marginBottom: "5px",
                                                                }}
                                                            >
                                                                -
                                                            </li>
                                                        )}
                                                    </ul>
                                                </td>
                                                <td
                                                    style={{
                                                        padding: "0px",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    <ul
                                                        style={{
                                                            listStyleType: "none",
                                                            padding: 0,
                                                            margin: 0,
                                                        }}
                                                    >
                                                        {val.receipt.length > 0 ? (
                                                            val.receipt.map((ele, idx) => {
                                                                const isLast =
                                                                    idx === val.receipt.length - 1;
                                                                return (
                                                                    <li
                                                                        key={idx}
                                                                        style={{
                                                                            paddingBottom: "5px",
                                                                            marginBottom: "5px",
                                                                            textAlign: "right",
                                                                            borderBottom: isLast
                                                                                ? "none"
                                                                                : "1px solid #ccc",
                                                                        }}
                                                                    >
                                                                        <span
                                                                            style={{
                                                                                padding: "8px",
                                                                            }}
                                                                        >
                                                                            {formatAmount(
                                                                                Number(ele.amount)
                                                                            )}
                                                                        </span>
                                                                    </li>
                                                                );
                                                            })
                                                        ) : (
                                                            <li
                                                                style={{
                                                                    paddingBottom: "5px",
                                                                    marginBottom: "5px",
                                                                }}
                                                            >
                                                                -
                                                            </li>
                                                        )}
                                                    </ul>
                                                </td>
                                                <td
                                                    style={{
                                                        padding: "0px",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    <ul
                                                        style={{
                                                            listStyleType: "none",
                                                            padding: 0,
                                                            margin: 0,
                                                        }}
                                                    >
                                                        {val.receipt.length > 0 ? (
                                                            val.receipt.map((ele, idx) => {
                                                                const isLast =
                                                                    idx === val.receipt.length - 1;
                                                                return (
                                                                    <li
                                                                        key={idx}
                                                                        style={{
                                                                            paddingBottom: "5px",
                                                                            marginBottom: "5px",
                                                                            borderBottom: isLast
                                                                                ? "none"
                                                                                : "1px solid #ccc",
                                                                        }}
                                                                    >
                                                                        {ele.bankRefNumber}
                                                                    </li>
                                                                );
                                                            })
                                                        ) : (
                                                            <li
                                                                style={{
                                                                    paddingBottom: "5px",
                                                                    marginBottom: "5px",
                                                                }}
                                                            >
                                                                -
                                                            </li>
                                                        )}
                                                    </ul>
                                                </td>
                                                <td>{val.paidUntilDate}</td>
                                                <td
                                                    style={{
                                                        padding: "0px",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    <ul
                                                        style={{
                                                            listStyleType: "none",
                                                            padding: 0,
                                                            margin: 0,
                                                            width: "90px",
                                                        }}
                                                    >
                                                        {val.deposits.length > 0 ? (
                                                            val.deposits.map((ele, idx) => {
                                                                const isLast =
                                                                    idx === val.deposits.length - 1;
                                                                return (
                                                                    <li
                                                                        key={idx}
                                                                        style={{
                                                                            paddingBottom: "5px",
                                                                            marginBottom: "5px",
                                                                            borderBottom: isLast
                                                                                ? "none"
                                                                                : "1px solid #ccc",
                                                                        }}
                                                                    >
                                                                        {moment(ele.date).format(
                                                                            "DD/MM/YYYY"
                                                                        )}
                                                                    </li>
                                                                );
                                                            })
                                                        ) : (
                                                            <li
                                                                style={{
                                                                    paddingBottom: "5px",
                                                                    marginBottom: "5px",
                                                                }}
                                                            >
                                                                -
                                                            </li>
                                                        )}
                                                    </ul>
                                                </td>
                                                <td
                                                    style={{
                                                        padding: "0px",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    <ul
                                                        style={{
                                                            listStyleType: "none",
                                                            padding: 0,
                                                            margin: 0,
                                                        }}
                                                    >
                                                        {val.deposits.length > 0 ? (
                                                            val.deposits.map((ele, idx) => {
                                                                const amount =
                                                                    parseFloat(ele.amount) || 0;
                                                                totalDeposit += amount;
                                                                const isLast =
                                                                    idx === val.deposits.length - 1;
                                                                return (
                                                                    <li
                                                                        key={idx}
                                                                        style={{
                                                                            paddingBottom: "5px",
                                                                            marginBottom: "5px",
                                                                            textAlign: "right",
                                                                            borderBottom: isLast
                                                                                ? "none"
                                                                                : "1px solid #ccc",
                                                                        }}
                                                                    >
                                                                        {`${formatAmount(amount)}`}
                                                                    </li>
                                                                );
                                                            })
                                                        ) : (
                                                            <li
                                                                style={{
                                                                    paddingBottom: "5px",
                                                                    marginBottom: "5px",
                                                                }}
                                                            >
                                                                -
                                                            </li>
                                                        )}
                                                    </ul>
                                                </td>
                                                <td style={{ textAlign: "right" }}>
                                                    {val.balanceAmount
                                                        ? formatAmount(Number(val.balanceAmount))
                                                        : "-"}
                                                </td>
                                                <td
                                                    style={{
                                                        textAlign: "right",
                                                        color: val.dayDiff < 0 ? "red" : "inherit",
                                                    }}
                                                >
                                                    {val.dayDiff}
                                                </td>

                                                <td style={{ textAlign: "right" }}>
                                                    {formatAmount(Number(val.dueAmount))}
                                                </td>
                                                <td style={{ textAlign: "center" }}>
                                                    {val?.vacantLabel === "Yes" &&
                                                    val?.terminatedDate
                                                        ? moment(val.terminatedDate).format(
                                                              "DD/MM/YYYY"
                                                          )
                                                        : "-"}
                                                </td>
                                                {/* <td
                                                    style={{ textAlign: "right" }}
                                                >{`Number(val.unitExpenses).toFixed(2)}</td> */}
                                                <td
                                                    style={{
                                                        padding: "0px",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    <ul
                                                        style={{
                                                            listStyleType: "none",
                                                            padding: 0,
                                                            margin: 0,
                                                            width: "85px",
                                                        }}
                                                    >
                                                        {val.expense.length > 0 ? (
                                                            val.expense.map((ele, idx) => {
                                                                const isLast =
                                                                    idx === val.expense.length - 1;
                                                                return (
                                                                    <li
                                                                        key={idx}
                                                                        style={{
                                                                            paddingBottom: "5px",
                                                                            marginBottom: "5px",
                                                                            borderBottom: isLast
                                                                                ? "none"
                                                                                : "1px solid #ccc",
                                                                        }}
                                                                    >
                                                                        {moment(ele.date).format(
                                                                            "DD/MM/YYYY"
                                                                        )}
                                                                    </li>
                                                                );
                                                            })
                                                        ) : (
                                                            <li
                                                                style={{
                                                                    paddingBottom: "5px",
                                                                    marginBottom: "5px",
                                                                }}
                                                            >
                                                                -
                                                            </li>
                                                        )}
                                                    </ul>
                                                </td>
                                                <td
                                                    style={{
                                                        padding: "0px",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    <ul
                                                        style={{
                                                            listStyleType: "none",
                                                            padding: 0,
                                                            margin: 0,
                                                            width: "200px",
                                                        }}
                                                    >
                                                        {val.expense.length > 0 ? (
                                                            val.expense.map((ele, idx) => {
                                                                const isLast =
                                                                    idx === val.expense.length - 1;
                                                                return (
                                                                    <li
                                                                        key={idx}
                                                                        style={{
                                                                            paddingBottom: "5px",
                                                                            marginBottom: "5px",
                                                                            borderBottom: isLast
                                                                                ? "none"
                                                                                : "1px solid #ccc",
                                                                        }}
                                                                    >
                                                                        {/* {ele?.expense_type?.name}
                                                                         */}
                                                                        {ele?.description
                                                                            ? ele?.description
                                                                            : ele?.remarks}
                                                                    </li>
                                                                );
                                                            })
                                                        ) : (
                                                            <li
                                                                style={{
                                                                    paddingBottom: "5px",
                                                                    marginBottom: "5px",
                                                                }}
                                                            >
                                                                -
                                                            </li>
                                                        )}
                                                    </ul>
                                                </td>
                                                <td
                                                    style={{
                                                        padding: "0px",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    <ul
                                                        style={{
                                                            listStyleType: "none",
                                                            padding: 0,
                                                            margin: 0,
                                                        }}
                                                    >
                                                        {val.expense.length > 0 ? (
                                                            val.expense.map((ele, idx) => {
                                                                const isLast =
                                                                    idx === val.expense.length - 1;
                                                                return (
                                                                    <li
                                                                        key={idx}
                                                                        style={{
                                                                            paddingBottom: "5px",
                                                                            marginBottom: "5px",
                                                                            textAlign: "right",
                                                                            borderBottom: isLast
                                                                                ? "none"
                                                                                : "1px solid #ccc",
                                                                        }}
                                                                    >
                                                                        <span
                                                                            style={{
                                                                                padding: "8px",
                                                                            }}
                                                                        >
                                                                            {formatAmount(
                                                                                Number(ele.amount)
                                                                            )}
                                                                        </span>
                                                                    </li>
                                                                );
                                                            })
                                                        ) : (
                                                            <li
                                                                style={{
                                                                    paddingBottom: "5px",
                                                                    marginBottom: "5px",
                                                                }}
                                                            >
                                                                -
                                                            </li>
                                                        )}
                                                    </ul>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                    <tr>
                                        <td></td>
                                        <td style={{ fontWeight: "bold" }}>Total</td>
                                        <td></td>
                                        <td></td>
                                        <td style={{ fontWeight: "bold", textAlign: "right" }}>
                                            {formatAmount(Number(data.totalRent))}
                                        </td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td style={{ fontWeight: "bold", textAlign: "right" }}>
                                            {formatAmount(Number(data.totalCollectedRent))}
                                        </td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td style={{ fontWeight: "bold", textAlign: "right" }}>
                                            {formatAmount(Number(totalDeposit))}
                                        </td>
                                        <td style={{ fontWeight: "bold", textAlign: "right" }}>
                                            {formatAmount(Number(data.totalBalance))}
                                        </td>
                                        <td></td>
                                        <td style={{ fontWeight: "bold", textAlign: "right" }}>
                                            {formatAmount(Number(data.totalDueAmount))}
                                        </td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td style={{ fontWeight: "bold", textAlign: "right" }}>
                                            {formatAmount(Number(data.totalUnitExpense))}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}>Summary</td>
                                        <td colSpan={15}></td>
                                        <td
                                            colSpan={3}
                                            style={{ textAlign: "center", fontWeight: "bold" }}
                                        >
                                            BUILDING EXPENSES
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan={17} style={{ textAlign: "right" }}></td>
                                        {data && data.propertyExpense.length > 0 ? (
                                            <React.Fragment>
                                                <td
                                                    style={{
                                                        padding: "0px",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    <ul
                                                        style={{
                                                            listStyleType: "none",
                                                            padding: 0,
                                                            margin: 0,
                                                        }}
                                                    >
                                                        {data.propertyExpense.map((val, index) => {
                                                            const isLast =
                                                                index ===
                                                                data.propertyExpense.length - 1;
                                                            return (
                                                                <li
                                                                    key={index}
                                                                    style={{
                                                                        paddingBottom: "5px",
                                                                        marginBottom: "5px",
                                                                        borderBottom: isLast
                                                                            ? "none"
                                                                            : "1px solid #ccc",
                                                                    }}
                                                                >
                                                                    {moment(val.date).format(
                                                                        "DD/MM/YYYY"
                                                                    )}
                                                                </li>
                                                            );
                                                        })}
                                                    </ul>
                                                </td>
                                                <td
                                                    style={{
                                                        padding: "0px",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    <ul
                                                        style={{
                                                            listStyleType: "none",
                                                            padding: 0,
                                                            margin: 0,
                                                            width: "200px",
                                                        }}
                                                    >
                                                        {data.propertyExpense.map((val, index) => {
                                                            const isLast =
                                                                index ===
                                                                data.propertyExpense.length - 1;
                                                            return (
                                                                <li
                                                                    key={index}
                                                                    style={{
                                                                        paddingBottom: "5px",
                                                                        marginBottom: "5px",
                                                                        borderBottom: isLast
                                                                            ? "none"
                                                                            : "1px solid #ccc",
                                                                    }}
                                                                >
                                                                    {val?.expense_type?.name}
                                                                </li>
                                                            );
                                                        })}
                                                    </ul>
                                                </td>
                                                <td
                                                    style={{
                                                        padding: "0px",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    <ul
                                                        style={{
                                                            listStyleType: "none",
                                                            padding: 0,
                                                            margin: 0,
                                                        }}
                                                    >
                                                        {data.propertyExpense.map((val, index) => {
                                                            const isLast =
                                                                index ===
                                                                data.propertyExpense.length - 1;
                                                            return (
                                                                <li
                                                                    key={index}
                                                                    style={{
                                                                        paddingBottom: "5px",
                                                                        marginBottom: "5px",
                                                                        textAlign: "right",
                                                                        borderBottom: isLast
                                                                            ? "none"
                                                                            : "1px solid #ccc",
                                                                    }}
                                                                >
                                                                    {formatAmount(
                                                                        Number(val.amount)
                                                                    )}
                                                                </li>
                                                            );
                                                        })}
                                                    </ul>
                                                </td>
                                            </React.Fragment>
                                        ) : (
                                            <>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                            </>
                                        )}
                                    </tr>

                                    <tr>
                                        <td></td>
                                        <td colSpan={3}>TOTAL RENT COLLECTED</td>
                                        <td style={{ textAlign: "right" }}>
                                            {formatAmount(Number(data.totalCollectedRent))}
                                        </td>
                                        <td colSpan={12}></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td colSpan={3}>TOTAL Deposit</td>
                                        <td style={{ textAlign: "right" }}>
                                            {formatAmount(Number(totalDeposit))}
                                        </td>
                                        <td colSpan={12}></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    {data?.otherIncome?.length > 0 &&
                                        data.otherIncome.map((val, index) => {
                                            totalOtherIncome += val.amount;
                                            return (
                                                <tr key={index}>
                                                    <td></td>
                                                    <td colSpan={3}>
                                                        OTHER INCOME ({val?.unit?.unitNumber})
                                                        {val.rentAdjustFromDeposit === true
                                                            ? "(Adjusted rent from deposit)"
                                                            : ""}
                                                    </td>
                                                    <td style={{ textAlign: "right" }}>
                                                        {formatAmount(Number(val.amount))}
                                                    </td>
                                                    <td colSpan={12}>
                                                        {" "}
                                                        {val?.remarks ? val.remarks : ""}
                                                    </td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                            );
                                        })}
                                    <tr>
                                        <td></td>
                                        <td colSpan={3}>TOTAL EXPENSE</td>
                                        <td style={{ textAlign: "right" }}>
                                            {formatAmount(Number(data.totalOverAllExpense))}
                                        </td>
                                        <td colSpan={12}></td>
                                        <td></td>
                                        <td style={{ fontWeight: "bold" }}>Total</td>
                                        <td style={{ textAlign: "right", fontWeight: "bold" }}>
                                            {data?.totalPropertyExpense
                                                ? formatAmount(Number(data?.totalPropertyExpense))
                                                : 0}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td colSpan={3}>NET INCOME</td>
                                        <td style={{ textAlign: "right" }}>
                                            {formatAmount(
                                                Number(
                                                    data.totalCollectedRent +
                                                        totalOtherIncome +
                                                        totalDeposit -
                                                        data.totalOverAllExpense
                                                )
                                            )}
                                        </td>
                                        <td colSpan={12}></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td colSpan={20}></td>
                                    </tr>
                                </>
                            ) : (
                                <tr>
                                    <td colSpan="11" style={{ textAlign: "center" }}>
                                        Loading...
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </Box>
    );
};
// };

export default IncomeExpenseDetailsV2;
